import React, {useState} from "react";

function ModelCut(props) {
    return (
        <div className="ModelDetails">
            <div className="ModelName">
                <p className="p1">{props.brandName}/women fall 2021</p>
                <p className="p1">{props.brandName}/women fall 2021</p>
                <p className="p1">{props.brandName}/women fall 2021</p>
                <p className="p2">{props.brandName}/women fall 2021</p>
                <p className="p2">{props.brandName}/women fall 2021</p>
                <p className="p2">{props.brandName}/women fall 2021</p>
            </div>
            <div className="ModelImage">
                {props.modelDetails.map((data) => {
                    return (
                        <a
                            href={`showroom/modelCutDetails?brandName=${props.brandName}&lookNo=${data.lookNo}`} //MODEL CUT NUMBER
                        >
                            <img src={`Images/Showroom/${data.image}`}></img>
                        </a>
                    );
                })}
            </div>
        </div>
    );
}

export default ModelCut;
